var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.getLoading)?_c('Loading'):_c('APIList'),(_vm.failedToLoad)?_c('FailedMessage',{attrs:{"message":_vm.failedToLoad}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }